import React from 'react';
import { Panel, PanelType } from '@fluentui/react';
import GettingStartedChecklist, { IGettingStartedChecklistProps } from './GettingStartedChecklist';
import { CHECKLIST_STRINGS } from './wizardStrings';

// A thin shell around the checklist. Nothing but chrome lives here on purpose: the checklist is
// container agnostic, so swapping this Panel for a Sentry-style Callout later is a change to this
// file alone.
//
// Non-blocking and light dismiss: onboarding must never trap the user. They can click straight
// past it into the app and the panel closes itself.

export interface IGettingStartedPanelProps extends IGettingStartedChecklistProps {
    isOpen: boolean;
    onDismiss: () => void;
}

const GettingStartedPanel: React.FC<IGettingStartedPanelProps> = (props) => {
    const { isOpen, onDismiss, ...checklistProps } = props;
    return (
        <Panel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.medium}
            headerText={CHECKLIST_STRINGS.panelTitle}
            isBlocking={false}
            isLightDismiss={true}
            closeButtonAriaLabel="Close"
        >
            <GettingStartedChecklist {...checklistProps} />
        </Panel>
    );
};

export default GettingStartedPanel;
